const fn = {
    init: () => {
        fn.bindEvents();
    },

    bindEvents: () => {
        var masonryEvents = ['load', 'resize'];
        masonryEvents.forEach(function (event) {
            window.addEventListener(event, fn.resizeAllMasonryItems());
        });

        fn.waitForImages();
    },

    resizeMasonryItem: (item) => {
        var grid = document.getElementsByClassName('masonry')[0];
        if (grid) {
            var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
                rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows')),
                gridImagesAsContent = item.querySelector('img.masonry-content');
            var rowSpan = Math.ceil((item.querySelector('.masonry-content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
            item.style.gridRowEnd = 'span ' + rowSpan;
            if (gridImagesAsContent) {
                item.querySelector('img.masonry-content').style.height = item.getBoundingClientRect().height + "px";
            }
        }
    },

    resizeAllMasonryItems: () => {
        var allItems = document.querySelectorAll('.masonry-item');
        if (allItems) {
            for (var i = 0; i < allItems.length; i++) {
                fn.resizeMasonryItem(allItems[i]);
            }
        }
    },

    waitForImages: () => {
        var allItems = document.querySelectorAll('.masonry-item');
        if (allItems) {
            for (var i = 0; i < allItems.length; i++) {
                $(allItems[i]).imagesLoaded((instance) => {
                    var item = instance.elements[0];
                    fn.resizeMasonryItem(item);
                });
            }
        }
    }
}

export default {
    can: () => document.querySelectorAll('.masonry-item').length,
    run: fn.init,
};
